import {Model} from "./";
import {Api} from "../api";

class ContentModel extends Model {

    constructor() {
        super(new Api("/content"));
    }

    getBrandsFromAdmin(thenFunction, errorFunction) {
        this.q.setDopUrl('/brands');
        this.q.read({}, thenFunction, errorFunction);
    }

    getDetailBrands(id, thenFunction, errorFunction) {
        this.q.setDopUrl('/detail-brand/'+id);
        this.q.read({}, thenFunction, errorFunction);
    }

    getTelegramBanners(thenFunction, errorFunction) {
        this.q.setDopUrl('/telegram-banners');
        this.q.read({}, thenFunction, errorFunction);
    }

    uploadTelegramBanner(formData, thenFunction, errorFunction) {
        
        this.q.setDopUrl('/telegram-banners');
        this.q.uploadFile(formData, thenFunction, errorFunction);
    }

    deleteTelegramBanner(fileName, thenFunction, errorFunction) {
        this.q.setDopUrl('/telegram-banners/' + fileName);
        this.q.delete({}, thenFunction, errorFunction);
    }

}

export default new ContentModel();
